export type SessionStatusTypes =
  | "DRAFT"
  | "PENDING"
  | "INPROGRESS"
  | "APPROVED"
  | "REJECTED"
  | "COMPLETED"
  | "ROSTERFINALIZED"
  | "NOT_GENERATED"
  | "GENERATED";

export const SessionStatusConstants: any = {
  DRAFT: {
    auiTableRowBorderClass: "aui-tr-normal",
    badgeText: "Draft",
    statusInfo: {
      "Sponsoring Org Admin":
        "This course is in Draft. Please complete the details and send request.",
      "Approving Org Admin": "",
      "Master Trainer": "",
    },
    title: "Draft",
  },
  PENDING: {
    auiTableRowBorderClass: "aui-tr-normal",
    badgeText: "Pending",
    statusInfo: {
      "Sponsoring Org Admin":
        "This course is Pending for review from {approvingOrgName}. You will be notified when the status of the course is updated.",
      "Approving Org Admin": "This course is Pending.",
      "Master Trainer": "",
    },
    title: "Pending",
  },
  INPROGRESS: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        ["The student roster is finalized, Generate certificate of attendance, Upload course coordinator workbook.",
          "Please complete the BEC course before starting BEC TOT."
        ],
      "Approving Org Admin": "This course is Approved and In Progress.",
      "Master Trainer":
        ["The student roster is finalized, Generate certificate of attendance, Upload course coordinator workbook.",
          "Please complete the BEC course before starting BEC TOT."
        ]
    },
    title: "In Progress",
  },
  TOTSTUDENTNOTADDED: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        ["The BEC course has been completed. Please start the BEC TOT course by clicking on the BEC TOT Tab below.",
          "This BEC TOT course is Approved. You can add student details and finalize the roster.",
        ],
      "Approving Org Admin": "This course is Approved and In Progress.",
      "Master Trainer":
      ["The BEC course has been completed. Please start the BEC TOT course by clicking on the BEC TOT Tab below.",
        "This BEC TOT course is Approved. You can add student details and finalize the roster.",
      ],
    },
    title: "In Progress",
  },
  TOTSTUDENTADDED: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        ["The BEC course has been completed. Please proceed with the BEC TOT course.",
          "The student roster is finalized, Generate certificate of attendance, Upload course coordinator workbook.",
        ],
      "Approving Org Admin": "This course is Approved and In Progress.",
      "Master Trainer":
        ["The BEC course has been completed. Please proceed with the BEC TOT course.",
          "The student roster is finalized, Generate certificate of attendance, Upload course coordinator workbook.",
        ],
    },
    title: "In Progress",
  },
  FEEDBACKREMINDERTOTINSTANCE: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        ["Download the BEC course completion certificate and note the reminder for BEC TOT.",
          "",
        ],
      "Approving Org Admin": "This course is Approved and In Progress.",
      "Master Trainer":
      ["Download the BEC course completion certificate and note the reminder for BEC TOT.",
        "",
      ],
    },
    title: "In Progress",
  },
  FEEDBACKREMINDERBECINSTANCE: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        ["",
          "Please complete the BEC course before starting BEC TOT.",
        ],
      "Approving Org Admin": "This course is Approved and In Progress.",
      "Master Trainer":
      ["",
        "Please complete the BEC course before starting BEC TOT.",
      ],
    },
    title: "In Progress",
  },
  INPROGRESSBECTOT: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Approving Org Admin":
        "This course is In Progress. Generate the certificate of completion for the BEC course."
    },
    title: "In Progress",
  },
  INPROGRESSTOTINSTANCE: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Approving Org Admin":
        ["This course is In Progress. Generate the certificate of completion for the BEC course.",
          ""
        ]
    },
    title: "In Progress",
  },
  INPROGRESSBECINSTANCE: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Approving Org Admin":
        ["",
          "This course is Approved and In Progress."
        ]
    },
    title: "In Progress",
  },
  TOTINPROGRESS: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        "This course is In Progress. Finalize Roster for {courseType} course.",
      "Approving Org Admin": "This course is In Progress.",
      "Master Trainer":
        "This course is In Progress. Finalize Roster for {courseType} course.",
    },
    title: "In Progress",
  },
  FEEDBACKNOTUPLOADED: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        "The student roster is Finalized. Generate the certificate of attendance and upload the course coordinator workbook after the course's end date and time.",
      "Master Trainer":
        "The student roster is Finalized. Generate the certificate of attendance and upload the course coordinator workbook after the course's end date and time.",
    },
    title: "In Progress",
  },
  FEEDBACKNOTUPLOADEDBECTOT: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        ["The student roster is finalized for {courseType} course. Generate the certificate of attendance and upload course coordinator workbook after the {courseType} course’s end date and time.",
          "Please complete the BEC course before starting BEC TOT."
        ],
      "Master Trainer":
        ["The student roster is finalized for {courseType} course. Generate the certificate of attendance and upload course coordinator workbook after the {courseType} course’s end date and time.",
          "Please complete the BEC course before starting BEC TOT."
        ],
    },
    title: "In Progress",
  },
  FEEDBACKNOTUPLOADEDTOTINSTANCE: { 
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        [ "The BEC course has been completed. Please proceed with the BEC TOT course.",
          "The student roster is finalized for {courseType} course. Generate the certificate of attendance and upload course coordinator workbook after the {courseType} course’s end date and time.",
        ],
      "Master Trainer":
        [ "The BEC course has been completed. Please proceed with the BEC TOT course.",
          "The student roster is finalized for {courseType} course. Generate the certificate of attendance and upload course coordinator workbook after the {courseType} course’s end date and time.",
        ],
    },
    title: "In Progress",
  },
  FEEDBACKNOTAPPROVED: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        ["The course coordinator workbook is pending review by {approvingOrgName}. You will be notified once it is approved.",
          "Please complete the BEC course before starting BEC TOT."
        ],
      "Master Trainer":
        ["The course coordinator workbook is pending review by {approvingOrgName}. You will be notified once it is approved.",
          "Please complete the BEC course before starting BEC TOT."
        ]
    },
    title: "In Progress",
  },
  FEEDBACKNOTAPPROVEDTOTINSTANCE: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        ["The BEC course has been completed. Please proceed with the BEC TOT course.",
          "The course coordinator workbook is pending review by {approvingOrgName}. You will be notified once it is approved."
        ],
      "Master Trainer":
        ["The BEC course has been completed. Please proceed with the BEC TOT course.",
          "The course coordinator workbook is pending review by {approvingOrgName}. You will be notified once it is approved."
        ],
    },
    title: "In Progress",
  },
  APPROVED: {
    auiTableRowBorderClass: "approveStatus",
    badgeText: "Approved",
    statusInfo: {
      "Sponsoring Org Admin":
        [ "This course is Approved. You can add student details and finalize the roster.",
        "Please complete the BEC course before starting BEC TOT."
        ],
      "Approving Org Admin": "This course is Approved.",
      "Master Trainer":
        ["This course is Approved. You can add student details and finalize the roster.",
          "Please complete the BEC course before starting BEC TOT."
        ]
    },
    title: "Approved",
  },
  ROSTERNOTFINLIASED: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        "This course is Approved. You can add or update student details and finalize the roster after the course's start date and time.",
      "Master Trainer":
        "This course is Approved. You can add or update student details and finalize the roster after the course's start date and time.",
    },
    title: "In Progress",
  },
  ROSTERNOTFINLIASEDBECINSTANCE: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        [ "This course is {status}. You can add or update the student details for the {courseType} course and finalize the roster after the {courseType} course's start date and time.",
          "Please complete the BEC course before starting BEC TOT."
        ],
      "Master Trainer":
        [ "This course is {status}. You can add or update the student details for the {courseType} course and finalize the roster after the {courseType} course's start date and time.",
          "Please complete the BEC course before starting BEC TOT."
        ]
    },
    title: "In Progress",
  },
  ROSTERNOTFINLIASEDBECTOT: {
    auiTableRowBorderClass: "aui-tr-pending",
    badgeText: "In-progress",
    statusInfo: {
      "Sponsoring Org Admin":
        [ "The BEC course has been completed. Please start the BEC TOT course.",
          "This course is {status}. You can add or update the student details for the {courseType} course and finalize the roster after the {courseType} course's start date and time."
        ],
      "Master Trainer":
        ["The BEC course has been completed. Please start the BEC TOT course.",
          "This course is {status}. You can add or update the student details for the {courseType} course and finalize the roster after the {courseType} course's start date and time."
        ]
    },
    title: "In Progress",
  },
  REJECTED: {
    auiTableRowBorderClass: "aui-tr-danger",
    badgeText: "Rejected",
    statusInfo: {
      "Sponsoring Org Admin":
        "Your course request has been Rejected by {approvingOrgName}. You are not permitted to conduct this course.",
      "Approving Org Admin": "This course was Rejected.",
      "Master Trainer": "",
    },
    title: "Rejected",
  },
  COMPLETED: {
    auiTableRowBorderClass: "aui-tr-success",
    badgeText: "Completed",
    statusInfo: {
      "Sponsoring Org Admin": "This course has been Completed.",
      "Approving Org Admin":
        "This course has been Completed. Generate the certificate of completion.",
      "Master Trainer": "This course has been Completed.",
    },
    title: "Completed",
  },
  COMPLETEDBECTOT: {
    auiTableRowBorderClass: "aui-tr-success",
    badgeText: "Completed",
    statusInfo: {
      "Approving Org Admin":
        "This course is completed. Generate the certificate of completion for the BEC TOT course",
    },
    title: "Completed",
  },
  ROSTERFINALIZED: {
    auiTableRowBorderClass: "aui-tr-success",
    badgeText: "Roster Finalized",
    statusInfo: "",
    title: "Roster Finalized",
  },
  NOT_GENERATED: {
    badgeText: "Not Generated",
  },
  FAILED: {
    badgeText: "Failed",
  },
  GENERATED: {
    badgeText: "Generated",
  },
  "": {
    auiTableRowBorderClass: "",
    badgeText: "",
    statusInfo: {
      "Sponsoring Org Admin": "",
      "Approving Org Admin": "",
      "Master Trainer": "",
    },
    title: "",
  },
};
